import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Eye, EyeOff, Lock } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
export function SignupPage() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [emailUpdates, setEmailUpdates] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const {
    signup
  } = useAuth();
  const navigate = useNavigate();
  const validate = () => {
    const newErrors: Record<string, string> = {};
    if (!firstName.trim()) newErrors.firstName = 'First name is required';
    if (!lastName.trim()) newErrors.lastName = 'Last name is required';
    if (!email.trim()) newErrors.email = 'Email is required';else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) newErrors.email = 'Enter a valid email address';
    if (!password) newErrors.password = 'Password is required';else if (password.length < 8) newErrors.password = 'Password must be at least 8 characters';
    if (!confirmPassword) newErrors.confirmPassword = 'Please confirm your password';else if (password !== confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {
      signup(`${firstName} ${lastName}`, email);
      navigate('/verify-email');
    }
  };
  return <div className="min-h-screen bg-aliceBlue flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-483">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center" data-id="element-484">
        <Link to="/" data-id="element-485">
          <img src="https://cdn.magicpatterns.com/uploads/u4AKTM42BTBGHrLv1PiYxT/Logo_3.png" alt="LawVo" className="h-10 object-contain mx-auto mb-8" data-id="element-486" />
        </Link>
        <h2 className="text-3xl font-bold text-primary" data-id="element-487">Create your account</h2>
        <p className="mt-3 text-secondary" data-id="element-488">
          Get access to your personalized Legal Health Check — identify risks,
          get your score, and build an action plan.
        </p>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-489">
        <div className="bg-white py-8 px-6 shadow-sm sm:rounded-xl sm:px-10 border border-borderColor" data-id="element-490">
          <form className="space-y-5" onSubmit={handleSubmit} noValidate data-id="element-491">
            <div className="grid grid-cols-2 gap-4" data-id="element-492">
              <div data-id="element-493">
                <label className="block text-sm font-medium text-primary mb-1" data-id="element-494">
                  First name
                </label>
                <input type="text" required value={firstName} onChange={e => {
                setFirstName(e.target.value);
                setErrors(prev => ({
                  ...prev,
                  firstName: ''
                }));
              }} className={`w-full px-4 py-3 rounded-lg border ${errors.firstName ? 'border-destructive' : 'border-borderColor'} focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none transition-all`} placeholder="Jane" data-id="element-495" />
                {errors.firstName && <p className="mt-1 text-xs text-destructive" data-id="element-496">
                    {errors.firstName}
                  </p>}
              </div>
              <div data-id="element-497">
                <label className="block text-sm font-medium text-primary mb-1" data-id="element-498">
                  Last name
                </label>
                <input type="text" required value={lastName} onChange={e => {
                setLastName(e.target.value);
                setErrors(prev => ({
                  ...prev,
                  lastName: ''
                }));
              }} className={`w-full px-4 py-3 rounded-lg border ${errors.lastName ? 'border-destructive' : 'border-borderColor'} focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none transition-all`} placeholder="Doe" data-id="element-499" />
                {errors.lastName && <p className="mt-1 text-xs text-destructive" data-id="element-500">
                    {errors.lastName}
                  </p>}
              </div>
            </div>

            <div data-id="element-501">
              <label className="block text-sm font-medium text-primary mb-1" data-id="element-502">
                Email address
              </label>
              <input type="email" required value={email} onChange={e => {
              setEmail(e.target.value);
              setErrors(prev => ({
                ...prev,
                email: ''
              }));
            }} className={`w-full px-4 py-3 rounded-lg border ${errors.email ? 'border-destructive' : 'border-borderColor'} focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none transition-all`} placeholder="you@example.com" data-id="element-503" />
              {errors.email && <p className="mt-1 text-xs text-destructive" data-id="element-504">{errors.email}</p>}
            </div>

            <div data-id="element-505">
              <label className="block text-sm font-medium text-primary mb-1" data-id="element-506">
                Password
              </label>
              <div className="relative" data-id="element-507">
                <input type={showPassword ? 'text' : 'password'} required value={password} onChange={e => {
                setPassword(e.target.value);
                setErrors(prev => ({
                  ...prev,
                  password: ''
                }));
              }} className={`w-full px-4 py-3 pr-12 rounded-lg border ${errors.password ? 'border-destructive' : 'border-borderColor'} focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none transition-all`} placeholder="Minimum 8 characters" data-id="element-508" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-secondary hover:text-primary transition-colors" data-id="element-509">
                  {showPassword ? <EyeOff className="w-5 h-5" data-id="element-510" /> : <Eye className="w-5 h-5" data-id="element-511" />}
                </button>
              </div>
              {errors.password && <p className="mt-1 text-xs text-destructive" data-id="element-512">
                  {errors.password}
                </p>}
            </div>

            <div data-id="element-513">
              <label className="block text-sm font-medium text-primary mb-1" data-id="element-514">
                Confirm password
              </label>
              <div className="relative" data-id="element-515">
                <input type={showConfirm ? 'text' : 'password'} required value={confirmPassword} onChange={e => {
                setConfirmPassword(e.target.value);
                setErrors(prev => ({
                  ...prev,
                  confirmPassword: ''
                }));
              }} className={`w-full px-4 py-3 pr-12 rounded-lg border ${errors.confirmPassword ? 'border-destructive' : 'border-borderColor'} focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none transition-all`} placeholder="Re-enter your password" data-id="element-516" />
                <button type="button" onClick={() => setShowConfirm(!showConfirm)} className="absolute right-3 top-1/2 -translate-y-1/2 text-secondary hover:text-primary transition-colors" data-id="element-517">
                  {showConfirm ? <EyeOff className="w-5 h-5" data-id="element-518" /> : <Eye className="w-5 h-5" data-id="element-519" />}
                </button>
              </div>
              {errors.confirmPassword && <p className="mt-1 text-xs text-destructive" data-id="element-520">
                  {errors.confirmPassword}
                </p>}
            </div>

            <div className="flex items-start gap-3" data-id="element-521">
              <input id="email-updates" type="checkbox" checked={emailUpdates} onChange={e => setEmailUpdates(e.target.checked)} className="mt-1 h-4 w-4 rounded border-borderColor text-violetBlue focus:ring-violetBlue" data-id="element-522" />
              <label htmlFor="email-updates" className="text-sm text-secondary" data-id="element-523">
                Send me occasional product updates and legal tips (optional)
              </label>
            </div>

            <button type="submit" className="w-full flex justify-center py-3.5 px-4 border border-transparent rounded-lg shadow-sm text-sm font-semibold text-white bg-violetBlue hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violetBlue transition-opacity" data-id="element-524">
              Create Account
            </button>
          </form>

          <div className="mt-6 flex items-center gap-2 justify-center text-xs text-secondary" data-id="element-525">
            <Lock className="w-3.5 h-3.5" data-id="element-526" />
            <span data-id="element-527">
              Your information is encrypted and securely stored in Canada.
            </span>
          </div>
        </div>

        <p className="mt-6 text-center text-sm text-secondary" data-id="element-528">
          Already have an account?{' '}
          <Link to="/login" className="font-semibold text-violetBlue hover:text-primary transition-colors" data-id="element-529">
            Log in
          </Link>
        </p>
      </motion.div>
    </div>;
}